import { toast } from "react-toastify";
import { ProductAPI } from "../constants/apiRoutes";
import { productActions } from "../reducers/product";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const createNewProduct = (data, navigate) => {
  return async (dispatch) => {
    dispatch(productActions.actionStart());
    try {
      await apiService.post(ProductAPI.create(), data);
      dispatch(productActions.actionSuccess("create"));
    } catch (err) {
      dispatch(productActions.clearError());
      handleError(err);
    }
  };
};

export const updateProduct = (data, navigate, id) => {
  return (dispatch) => {
    dispatch(productActions.actionStart());
    return apiService
      .put(ProductAPI.update(id), data)
      .then((response) => {
        dispatch(productActions.actionSuccess("update"));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const updateItem = (data) => {
  return (dispatch) => {
    // "kao" da je prošlo OK
    dispatch({
      type: "product/update/fulfilled",
      payload: data.rowData,
    });
  };
};

export const deleteProduct = (id) => {
  return (dispatch) => {
    return apiService
      .delete(ProductAPI.delete(id))
      .then((response) => {
        toast.success("Uspešno ste obrisali proizvod", {
          theme: "colored",
        });

        dispatch(fetchProductList());
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchProductList = () => {
  return (dispatch) => {
    return apiService
      .get(ProductAPI.list())
      .then((response) => {
        dispatch(productActions.fetchProductList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};

export const fetchProductById = (id = 0) => {
  return (dispatch) => {
    return apiService
      .get(ProductAPI.getById(id))
      .then((response) => {
        dispatch(productActions.fetchProductDetail(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
